<template>
    <div class="" style="  border-bottom: 1px #d9d9d9 solid;overflow: hidden;background: #EAECF2;padding: 4px 4px 0 4px;">
      <img class="h-100 w-100" :class="isImage(type) ? 'image' : 'more'"  loading="lazy"
                :src="isImage(type) ? url : getFileThumb(id)" />
    </div>
  </template>
  
  <script>
  import { getFileExtension } from "../../lib/text-utils";
  
  export default {
    name: "File",
    props: {
      id: {
        type: String
      },
      type : {
        type : String
      },
      url : {
        type : String
      }
    },
    data() {
      return {
        name: "",
        contentType: "",
        source: ""
      };
    },
    methods: {
      isImage (value){
        return value.toLowerCase().includes('image');
      },
      getFileThumb(file) {
        const extension = getFileExtension(file.toLowerCase());
        switch (extension) {
          case "m4v":
          case "mp4":
          case "avi":
          case "mkv":
          case "wmv":
          case "flv":
          case "mov":
          case "3gp":
          case "3g2": {
            return "/assets/icon/icon-file-video.svg";
          }
          case "pdf": {
            return "/assets/icon/icon-file-pdf.svg";
          }
          case "zip": {
            return "/assets/icon/icon-file-zip.svg";
          }
          case "doc":
          case "docx":
          case "txt":
          case "odt":
          case "tex":
          case "xml":
          case "html": {
            return "/assets/icon/icon-file-doc.svg";
          }
          case "xlsx":
          case "xls":
          case "xlsm":
          case "xlsb": {
            return "/assets/icon/icon-file-excel.svg";
          }
          default:
            return "/assets/icon/icon-file-doc.svg";
      }
    },
    },
    created() {
      // this.getNameFile();
    }
  };
  </script>
  
  <style scoped>
  .image{
    object-fit: cover;
    border-radius: 4px 4px 0 0;
  }
  .more {
    padding: 32px;
  }
  </style>